<div class="song">
  <div class="song__cover">
    <div class="song__cover-group with-icon"></div>
  </div>
  <div class="song__content song__content-more">
    <div class="song__name">
      <span class="song__name-link">{{ group.title }}</span>
    </div>
    <div class="song__artist">
      <span class="song__artist-link">{{ 'subscriber-rules-page.contacts-number' | translate: {contactsNumber: group.numbers.length} }}</span>
    </div>
  </div>
  <div class="song__more-controls" *ngIf="showControls">
    <div class="song__more-controls-trigger icon icon-more" (click)="info()"></div>
  </div>
</div>
